import { render, staticRenderFns } from "./WidgetComplaints.vue?vue&type=template&id=175a4e08&scoped=true"
import script from "./WidgetComplaints.vue?vue&type=script&lang=js"
export * from "./WidgetComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a4e08",
  null
  
)

export default component.exports